import * as React from "react";

import { storeValue, userAddressKey } from '../storage/storage-utils';
import { trackEvent } from '../analytics/tracking';
import SearchLocationInput from '../googlemaps/SearchLocationInput';
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded';
import PropTypes from 'prop-types';

import '../registration/MaterialUI.module.css';
import styles from './Address.module.css';

/**
 * Provide a form to edit the location-search selected address ( minus apartment number ) 
 * 
 * TODO: handle warning for clicking on button prior to search
 * 
 * NOTE: custom "buttonText" is fragile since the ellipsis handling requires 
 * input padding equal to the width of the text (e.g. 8rem for "Get Started") 
 */
const AddressSearch = ({
  buttonText="Get Started",
  arrowOnly,
  handleUpdate, /* e.g. pass address to parent */
  onComplete,
  trackingLabel,
  pinColor='#0000008a',
  isWideDesign
}) => {

  const [addressSelected, setAddressSelected] = React.useState();

  const handleAddressSelection = (response) => {
    if (response.address) {
      const { 
        address: street_address,
        city,
        stateShort: state,
        zipCode: zip_code,
      } = response;
      
      const address = { street_address, city, state, zip_code }
      


      // set address in parent component
      if (handleUpdate) {
        handleUpdate(address);
      }
      storeValue(userAddressKey, JSON.stringify(address));

      setAddressSelected(true);
    } else {
      trackEvent('error_address_search', 'address not returned');
    }
  };

  const handleOnComplete = () => {
    if (trackingLabel) {
      trackEvent(trackingLabel);
    }
    // e.g. continue to home page
    onComplete();
  };

  // iframed home page search 
  const extraStyle = isWideDesign ? styles.wide : '';
  const arrowStyle = arrowOnly ? styles.arrowOnly : '';

  return (
    <div className={`${styles.inputWrap} ${extraStyle} ${arrowStyle}`}>
      <div className={styles.pinIcon}>
        <LocationOnRoundedIcon fontSize={'inherit'} style={{color:pinColor}} />
      </div>
      <SearchLocationInput onSelection={handleAddressSelection} />
      {/* Marketing site shows arrow only for mobile */}
      { addressSelected  
        ? <button className={`${styles.continueButton} ${styles.enabledButton}`} onClick={handleOnComplete}>
            <ArrowForwardRoundedIcon fontSize={'inherit'} style={{verticalAlign:'-8px'}}/>
            { arrowOnly
              ? <></>
              : <span className={styles.buttonText}>{buttonText}</span>           
            }
         </button>
        : <button className={`${styles.continueButton} ${styles.disabledButton}`}>
            <ArrowForwardRoundedIcon fontSize={'inherit'} style={{verticalAlign:'-8px'}}/>
            { arrowOnly
              ? <></>
              : <span className={styles.buttonText}>{buttonText}</span>           
            }
          </button> 
      }
    </div>
  );
}

AddressSearch.propTypes = {
  buttonText: PropTypes.string,
  arrowOnly: PropTypes.bool,
  storageOnly: PropTypes.bool,
  handleUpdate: PropTypes.func,
  onComplete: PropTypes.func.isRequired,
  trackingLabel: PropTypes.string,
  pinColor: PropTypes.string,
  isWideDesign: PropTypes.bool
}

export default AddressSearch;
